import { Injectable, inject } from '@angular/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { TranslateService } from '@ngx-translate/core';

/**
 * Datepicker UI strings (mostly screen-reader labels) sourced from the
 * translation files; refreshed on every language change.
 */
@Injectable()
export class TranslatedDatepickerIntl extends MatDatepickerIntl {
  private readonly translate = inject(TranslateService);

  constructor() {
    super();
    this.updateLabels();
    this.translate.onLangChange.subscribe(() => {
      this.updateLabels();
      this.changes.next();
    });
  }

  private updateLabels(): void {
    const instant = (key: string): string => this.translate.instant(`material.datepicker.${key}`);
    this.calendarLabel = instant('calendarLabel');
    this.openCalendarLabel = instant('openCalendarLabel');
    this.closeCalendarLabel = instant('closeCalendarLabel');
    this.prevMonthLabel = instant('prevMonthLabel');
    this.nextMonthLabel = instant('nextMonthLabel');
    this.prevYearLabel = instant('prevYearLabel');
    this.nextYearLabel = instant('nextYearLabel');
    this.prevMultiYearLabel = instant('prevMultiYearLabel');
    this.nextMultiYearLabel = instant('nextMultiYearLabel');
    this.switchToMonthViewLabel = instant('switchToMonthViewLabel');
    this.switchToMultiYearViewLabel = instant('switchToMultiYearViewLabel');
  }
}
